import { ReactNode, forwardRef } from 'react';

import { Flex } from '@spotify-internal/encore-web';

import { asDialogSlot } from './composition';

export type HeaderProps = {
  className?: string;
  children?: ReactNode;
  dense?: boolean;
};

export const Header = forwardRef<HTMLDivElement, HeaderProps>((props, ref) => {
  const { className, children } = props;

  return (
    <Flex direction="column" className={className} ref={ref}>
      {children}
    </Flex>
  );
});

Header.displayName = 'DialogComposite.Header';

asDialogSlot(Header, 'header');

export default Header;
